import { invalidIndex } from './invalid-index'
import { isNumber } from './is-number'

export function invalidIndexs<T>(
  indices: number[],
  existing: readonly T[]
): boolean {
  for (const i of indices) {
    if (!existing[i] || !isNumber(i) || invalidIndex(indices[i])) {
      return true
    }
  }
  return false
}
